import { useState, Suspense, useEffect, useCallback } from "react";
import { Grid } from "@mui/material";
import { SubHeader } from "../../../..";
import ListAltIcon from "@mui/icons-material/ListAlt";

import "./claimDetailsPdf.css";
import { ClaimLine, ClaimLinesProps } from "../../../../../../types/components/EOB.types";
import { dateTimeZoneConverter } from "../../../../../../utils/commonFunctions/date";
import { dollarize } from "../../../../../../utils/commonFunctions/dollarize";

const columns = [
	"Type of Service",
	"Service From",
	"Service Thru",
	"Total Charge",
	"Discount /Penalty",
	"Eligible Expense",
	"Not Covered",
	"Rmk Cd",
	"Deductible Applied",
	"Paid At %",
	"Benefits Paid"
];

const dollarizeColumns = [
	"Total Charge",
	"Discount /Penalty",
	"Eligible Expense",
	"Not Covered",
	"Deductible Applied",
	"Paid At %",
	"Benefits Paid"
];

const ClaimDetailsPdf = (props: ClaimLinesProps): JSX.Element => {
	const [EOB, setEOB] = useState([
		{
			type_of_service: "DMJ2",
			service_from: "4-5-2021",
			service_thru: "4-5-2021",
			total_charge: "$1325.00",
			not_covered: "$-250.74",
			discount: "$50.00",
			eligible_expense: "$250.74",
			rmk_cd: "7, 2",
			deductible_applied: "$0.00",
			paid_at: "50",
			benefits_paid: "$125.37"
		},
		{
			type_of_service: "DMJ2",
			service_from: "4-5-2021",
			service_thru: "4-5-2021",
			total_charge: "$1325.00",
			not_covered: "$-250.74",
			discount: "$50.00",
			eligible_expense: "$250.74",
			expl_codes: "7, 2",
			deductible_applied: "$0.00",
			paid_at: "50",
			benefits_paid: "$125.37"
		},
		{
			type_of_service: "DMJ2",
			service_from: "4-5-2021",
			service_thru: "4-5-2021",
			total_charge: "$1325.00",
			not_covered: "$-250.74",
			discount: "$50.00",
			eligible_expense: "$250.74",
			expl_codes: "7, 2",
			deductible_applied: "$0.00",
			paid_at: "50",
			benefits_paid: "$125.37"
		},
		{
			type_of_service: "DMJ2",
			service_from: "4-5-2021",
			service_thru: "4-5-2021",
			total_charge: "$1325.00",
			not_covered: "$-250.74",
			discount: "$50.00",
			eligible_expense: "$250.74",
			expl_codes: "7, 2",
			deductible_applied: "$0.00",
			paid_at: "50",
			benefits_paid: "$125.37"
		},
		{
			type_of_service: "DMJ2",
			service_from: "4-5-2021",
			service_thru: "4-5-2021",
			total_charge: "$1325.00",
			not_covered: "$-250.74",
			discount: "$50.00",
			eligible_expense: "$250.74",
			expl_codes: "7, 2",
			deductible_applied: "$0.00",
			paid_at: "50",
			benefits_paid: "$125.37"
		},
		{
			type_of_service: "DMJ2",
			service_from: "4-5-2021",
			service_thru: "4-5-2021",
			total_charge: "$1325.00",
			not_covered: "$-250.74",
			discount: "$50.00",
			eligible_expense: "$250.74",
			expl_codes: "7, 2",
			deductible_applied: "$0.00",
			paid_at: "50",
			benefits_paid: "$125.37"
		},
		{
			type_of_service: "DMJ2",
			service_from: "4-5-2021",
			service_thru: "4-5-2021",
			total_charge: "$1325.00",
			not_covered: "$-250.74",
			discount: "$50.00",
			eligible_expense: "$250.74",
			expl_codes: "7, 2",
			deductible_applied: "$0.00",
			paid_at: "50",
			benefits_paid: "$125.37"
		},
		{
			type_of_service: "DMJ2",
			service_from: "4-5-2021",
			service_thru: "4-5-2021",
			total_charge: "$1325.00",
			not_covered: "$-250.74",
			discount: "$50.00",
			eligible_expense: "$250.74",
			expl_codes: "7, 2",
			deductible_applied: "$0.00",
			paid_at: "50",
			benefits_paid: "$125.37"
		},
		{
			type_of_service: "DMJ2",
			service_from: "4-5-2021",
			service_thru: "4-5-2021",
			total_charge: "$1325.00",
			not_covered: "$-250.74",
			discount: "$50.00",
			eligible_expense: "$250.74",
			expl_codes: "7, 2",
			deductible_applied: "$0.00",
			paid_at: "50",
			benefits_paid: "$125.37"
		}
	]);
	const [claimLines, setClaimLines] = useState<ClaimLine[]>([]);
	const [claimLineAggregation, setClaimLineAggregation] = useState<any>(null);

	const getClaimLineAggregation = useCallback(() => {
		let not_covered: number | string = 0,
			discount: number | string = 0,
			total_charge: number | string = 0,
			eligible_expense: number | string = 0,
			deductible_applied: number | string = 0,
			benefits_paid: number | string = 0;

		props.claimLines.forEach((claimLine: any) => {
			const { CHGAMT, EERSP, DEDAMT, COPMT, COINAMT, LNDISCAMT, ADJCVRD, PLNRESP } = claimLine;

			const notCovered = EERSP - DEDAMT - COPMT - COINAMT;
			if (notCovered) {
				not_covered = not_covered + notCovered;
			}
			if (LNDISCAMT) {
				discount = discount + LNDISCAMT;
			}
			if (CHGAMT) {
				total_charge = total_charge + CHGAMT;
			}
			if (ADJCVRD) {
				eligible_expense = eligible_expense + ADJCVRD;
			}
			if (DEDAMT) {
				deductible_applied = deductible_applied + DEDAMT;
			}
			if (COINAMT) {
				benefits_paid = benefits_paid + PLNRESP;
			}
		});
		if (total_charge) {
			total_charge = dollarize(Number(total_charge));
		}
		if (discount) {
			discount = dollarize(Number(discount));
		}
		if (eligible_expense) {
			eligible_expense = dollarize(Number(eligible_expense));
		}
		if (not_covered) {
			not_covered = dollarize(Number(not_covered));
		}
		if (deductible_applied) {
			deductible_applied = dollarize(Number(deductible_applied));
		}
		if (benefits_paid) {
			benefits_paid = dollarize(Number(benefits_paid));
		}
		setClaimLineAggregation(
			Object.assign(
				{},
				{
					type_of_service: "TOTALS",
					service_from: "",
					service_thru: "",
					CHGAMT: total_charge,
					LNDISCAMT: discount,
					ADJCVRD: eligible_expense,
					not_covered,
					expl_codes: "",
					DEDAMT: deductible_applied,
					paid_at: "",
					PLNRESP: benefits_paid
				}
			)
		);
	}, [props.claimLines]);

	useEffect(() => {
		getClaimLineAggregation();
		const _claimLines: ClaimLine[] = [];
		props?.claimLines.forEach((claimLine: any) => {
			const {
				TOS,
				INCFRMDT,
				INCTODT,
				EXPLCD01,
				EXPLCD02,
				EXPLCD03,
				CHGAMT,
				EERSP,
				DEDAMT,
				COPMT,
				COINAMT,
				LNDISCAMT,
				ADJCVRD,
				PERC,
				PLNRESP
			} = claimLine;
			let remarkCode = "";
			if (EXPLCD01) remarkCode = remarkCode + EXPLCD01;
			if (EXPLCD02) remarkCode = remarkCode + ", " + EXPLCD02;
			if (EXPLCD03) remarkCode = remarkCode + ", " + EXPLCD03;
			const notCovered = EERSP - DEDAMT - COPMT - COINAMT;
			// console.log("notCovered", notCovered);
			_claimLines.push({
				"Type of Service": TOS,
				"Service From": dateTimeZoneConverter(INCFRMDT),
				"Service Thru": dateTimeZoneConverter(INCTODT),
				"Total Charge": CHGAMT ? CHGAMT : 0,
				"Discount /Penalty": LNDISCAMT ? LNDISCAMT : 0,
				"Eligible Expense": ADJCVRD ? ADJCVRD : 0,
				"Not Covered": notCovered ? notCovered : 0,
				"Rmk Cd": remarkCode,
				"Deductible Applied": DEDAMT ? DEDAMT : 0,
				"Paid At %": PERC ? PERC : 0,
				"Benefits Paid": PLNRESP ? PLNRESP : 0
			});
		});
		setClaimLines(Object.assign([], _claimLines));
	}, [getClaimLineAggregation, props?.claimLines]);

	if (claimLineAggregation === null) {
		return <></>;
	}

	return (
		<>
			<Suspense fallback={<div />}>
				<SubHeader icon={<ListAltIcon />} title="Claim Details" isPrintable={true} />
			</Suspense>
			<div className="claim-details-pdf">
				<Grid container justifyContent="center" className="column-header-row">
					{columns.map((column, index) => {
						return (
							<Grid
								item
								xl={index === 8 ? 2 : 1}
								lg={index === 8 ? 2 : 1}
								key={index}
								className={index === columns.length - 1 ? "" : "column-header-container"}
								style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}
							>
								<div style={{ display: "inline-flex" }}>
									<div className="column-header">{column}</div>
								</div>
							</Grid>
						);
					})}
				</Grid>
				{claimLines.map((row, index) => {
					const items = { ...row };
					return (
						<Grid container justifyContent="center" key={index} className="column-item-row">
							{Object.entries(items).map(([key, value], index) => {
								return (
									<Grid
										xl={index === 8 ? 2 : 1}
										lg={index === 8 ? 2 : 1}
										key={index}
										className={
											index === Object.entries(items).length - 1 ? "" : "column-item-container"
										}
										style={{
											flex: 1,
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
											height: "20px"
										}}
									>
										<div style={{ display: "inline-flex" }}>
											<div className="column-item">
												{dollarizeColumns.includes(key) ? dollarize(value as number) : value}
											</div>
										</div>
									</Grid>
								);
							})}
						</Grid>
					);
				})}
				<Grid container justifyContent="center" className="column-item-row">
					{Object.entries(claimLineAggregation).map(([key, value], index) => {
						return (
							<Grid
								xl={index === 8 ? 2 : 1}
								lg={index === 8 ? 2 : 1}
								key={index}
								className={
									index === Object.entries(claimLineAggregation).length - 1
										? ""
										: "column-item-container"
								}
								style={{
									flex: 1,
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									height: "20px"
								}}
							>
								<div style={{ display: "inline-flex" }}>
									<div className="column-item">{value}</div>
								</div>
							</Grid>
						);
					})}
				</Grid>
			</div>
		</>
	);
};

export default ClaimDetailsPdf;
